import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f6413ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "section-5"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, " View more relevant products ", -1))
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "box-pagination" }

import { onMounted, ref, computed, reactive } from 'vue';
  import { IProduct, IVariant } from '@/types/product';
  import { request } from '@/utils';

  interface IProps {
    product: IProduct;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    product: null
  },
  setup(__props: any) {

const props = __props as {
    product: IProduct;
  }

  
  const list = ref<Array<IVariant>>([]);
  const pagination = reactive({
    total: 0,
    page: 1,
    perPage: 3
  });

  const taxonIds = computed(() => props.product.taxons.map(item => item.id));

  async function fetchVariants(params: { page?: number; per_page?: number; } = {}) {
    const { data, meta } = (await request.get('/bean/variants', { params: { page: 1, per_page: pagination.perPage, ...params, taxons_id_in: taxonIds.value } })) as any;
    list.value = data;
    Object.assign(pagination, {
      perPage: meta.per_page,
      page: meta.page,
      total: meta.total
    });
  }

  function handlePagination(page: any) {
    fetchVariants({ page });
  }

  onMounted(() => {
    if (taxonIds.value.length) {
      fetchVariants();
    }
  });

return (_ctx: any,_cache: any) => {
  const _component_AppCardVariant = _resolveComponent("AppCardVariant")!
  const _component_AppPagination = _resolveComponent("AppPagination")!

  return (list.value.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "col-12 col-md-4"
              }, [
                _createVNode(_component_AppCardVariant, {
                  modelValue: list.value[index],
                  "onUpdate:modelValue": ($event: any) => ((list.value[index]) = $event),
                  class: "product-item"
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_AppPagination, _mergeProps(_unref(pagination), {
              simple: "",
              onChange: handlePagination
            }), null, 16)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})